<template>
    <div>    
      <div class="row">
            <div class="col-md-12" style="margin-top: -40px;">
                <graficopie  	:titulo="''"
                                :subtitulo="''"
                                :rotulo="'DETALHES:'"
                                :legendas="legendasfinanceiro"
                                :dados="dadospedcompra"
                                :visualizarlegenda="false"
                                :posicaolabel="'outside'"
                ></graficopie>
            </div>
            <div class="col-md-12">
                <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px;">
                    <li v-for="(item, indice) in dadospedcompra" :key="indice" class="li-item-card-dash" style="height: 15px;">
                        <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                        <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.media)) }}%)
                        </span>
                    </li>
                </ul>                                            
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoPie from '../../components/cmpgraficopie.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
    'graficopie'       : GraficoPie,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasfinanceiro : [],
       
        showpopover             : false,
        isloading               : false,  
        totalpedcompra                : 0,
        usuariologado           : this.$store.state.usuario,

        dadospedcompra        : []
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        hidepopover(){
          setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
          
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmediafaturados(){
            let mediafat = 0;

            if(this.lstresumopedidos){
                mediafat = this.lstresumopedidos.totalfaturado / this.lstresumopedidos.qf;
            }
            return mediafat;
        }, 
        mtdmargemlucrogeral() {
          var vself               = this;
      
          const ptotalaberto		  = vself.lstresumopedidos.totalaberto;
          const ptotalfaturado	  = vself.lstresumopedidos.totalfaturado;
          const ptotalcusto 		  = vself.lstresumopedidos.totalcusto;
                
          let totalgeral          = ptotalaberto + ptotalfaturado;

          let dif                 = (parseFloat(totalgeral) - parseFloat(ptotalcusto))

          vself.margemlucrogeral  = 0;
          vself.margemlucrogeral  = dif / totalgeral * 100;
          
        },
       mtdresultadofaturamento(){
          var vself           = this;
        
          vself.$emit('handlerLoader', true);
          let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
      
 
          let parametros      = [
              {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
              {parametro: 'op',           valor : 'dash'},
              {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
              {parametro: 'periodo',      valor : periodo},
              {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
              {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
              {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
              {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
              {parametro: 'patharquivos', valor : ''},
          ];
          let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
          retorno.then(function (response) {
              //pedcompra pie 
              vself.totalpedcompra = parseFloat(response.data.digitacao) + parseFloat(response.data.aguardando) + parseFloat(response.data.entregue) + parseFloat(response.data.cancelado);
              vself.dadospedcompra = [
                    {value: parseFloat(response.data.digitacao),  name: 'EM DIGITAÇÃO',  media : parseFloat(response.data.digitacao) > 0 ? parseFloat(response.data.digitacao) / vself.totalpedcompra * 100 : 0},
                    {value: parseFloat(response.data.aguardando), name: 'AGUARDANDO',  media : parseFloat(response.data.aguardando) > 0 ? parseFloat(response.data.aguardando) / vself.totalpedcompra * 100 : 0},                        
                    {value: parseFloat(response.data.entregue),   name: 'ENTREGUE',    media : parseFloat(response.data.entregue) > 0 ? parseFloat(response.data.entregue) / vself.totalpedcompra * 100 : 0},
                    {value: parseFloat(response.data.cancelado),  name: 'CANCELADO',      media : parseFloat(response.data.cancelado) > 0 ? parseFloat(response.data.cancelado) / vself.totalpedcompra * 100 : 0}                   
              ];
              //fim
              vself.legendasfinanceiro = util.gerardadoslegendagrafico(vself.dadospedcompra);
              vself.$emit('handlerLoader', false);										
          }).catch(function (response) {
              vself.dadosvendedores = [];
              //loader.hide();
              vself.$emit('handlerLoader', false);	
          });                
      },
  },
  mounted(){


    setTimeout(() => {
         this.mtdresultadofaturamento();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
